<template>
  <fragment>
    <g
      id="Mole_Position_A-19-1-1"
      v-if="data.value === 'type-2' && data.position === 'b'"
    >
      <circle cx="217.12" cy="188.52" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-2"
      v-if="data.value === 'type-3' && data.position === 'b'"
    >
      <circle cx="128.45" cy="229.8" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-3"
      v-if="data.value === 'type-1' && data.position === 'b'"
    >
      <circle cx="101.99" cy="190.05" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-4"
      v-if="data.value === 'type-4' && data.position === 'b'"
    >
      <circle cx="191.08" cy="229.8" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-5"
      v-if="data.value === 'type-5' && data.position === 'b'"
    >
      <circle cx="100.46" cy="156.63" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-6"
      v-if="data.value === 'type-6' && data.position === 'b'"
    >
      <circle cx="219.17" cy="156.63" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-7"
      v-if="data.value === 'type-7' && data.position === 'b'"
    >
      <circle cx="165.84" cy="135.64" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-1-2"
      v-if="data.value === 'type-2' && data.position === 'm'"
    >
      <circle cx="217.12" cy="183.52" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-2-2"
      v-if="data.value === 'type-3' && data.position === 'm'"
    >
      <circle cx="128.45" cy="224.8" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-3-2"
      v-if="data.value === 'type-1' && data.position === 'm'"
    >
      <circle cx="101.99" cy="185.05" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-4-2"
      v-if="data.value === 'type-4' && data.position === 'm'"
    >
      <circle cx="191.08" cy="224.8" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-5-2"
      v-if="data.value === 'type-5' && data.position === 'm'"
    >
      <circle cx="100.46" cy="151.63" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-6-2"
      v-if="data.value === 'type-6' && data.position === 'm'"
    >
      <circle cx="219.17" cy="151.63" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-7-2"
      v-if="data.value === 'type-7' && data.position === 'm'"
    >
      <circle cx="165.84" cy="130.64" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-1-3"
      v-if="data.value === 'type-2' && data.position === 't'"
    >
      <circle cx="217.12" cy="178.52" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-2-3"
      v-if="data.value === 'type-3' && data.position === 't'"
    >
      <circle cx="128.45" cy="219.8" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-3-3"
      v-if="data.value === 'type-1' && data.position === 't'"
    >
      <circle cx="101.99" cy="180.05" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-4-3"
      v-if="data.value === 'type-4' && data.position === 't'"
    >
      <circle cx="191.08" cy="219.8" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-5-3"
      v-if="data.value === 'type-5' && data.position === 't'"
    >
      <circle cx="100.46" cy="146.63" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-6-3"
      v-if="data.value === 'type-6' && data.position === 't'"
    >
      <circle cx="219.17" cy="146.63" r="1.53" fill="#3f3d3e" />
    </g>
    <g
      id="Mole_Position_A-19-1-7-3"
      v-if="data.value === 'type-7' && data.position === 't'"
    >
      <circle cx="165.84" cy="125.64" r="1.53" fill="#3f3d3e" />
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarMoleA',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
